import { render, staticRenderFns } from "./ApplyApproval.vue?vue&type=template&id=b4907912"
import script from "./ApplyApproval.vue?vue&type=script&lang=js"
export * from "./ApplyApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports